import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Status from 'FielderUtils/autoassign/processTaskStatus';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
const statusStyles = {
  'Fielder-task-auto-assigning': {
    backgroundColor: '#b7e9fc',
    color: '#2489b1',
  },
  'Fielder-task-auto-assigning-failed': {
    backgroundColor: '#e9343469',
    color: '#c21010',
  },
  'Fielder-task-arrived': {
    backgroundColor: '#dce4009c',
    color: '#dce400',
  },
  'Fielder-task-finish': {
    backgroundColor: '#3ad38e79',
    color: '#137c4d',
  },
  'Fielder-task-managing': {
    backgroundColor: '#63a1e781',
    color: '#0f5099',
  },
};

const AutoAssignTaskStatus = ({ value }) => {
  const lan = useLanguage();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const [text, setText] = useState('');
  const [colorKey, setColorKey] = useState('');

  useEffect(() => {
    switch (value) {
      case Status.EXECUTING:
        setColorKey('Fielder-task-auto-assigning');
        setText(lan.executingAutoassign);
        break;
      case Status.FAILED_NO_AGENTS_AVAILABLE:
      case Status.FAILED_NO_SKILLS:
      case Status.FAILED_AVAILABLE_AGENTS_IN_MULTIPLE_TEAMS:
        setColorKey('Fielder-task-auto-assigning-failed');
        setText(lan.unsuccessful);
        break;
      case Status.RETRYING:
        setColorKey('Fielder-task-arrived');
        setText(lan.retrying);
        break;
      case Status.SUCCESSFULL:
        setColorKey('Fielder-task-finish');
        setText(lan.successful);
        break;
      case Status.WAITING:
        setColorKey('Fielder-task-managing');
        setText(lan.waiting);
        break;
      default:
        return;
    }
  }, [value, lan]);

  let variant = 'body2';
  if (isXs) variant = 'caption';
  else if (isSm) variant = 'body2';
  else if (isMd) variant = 'subtitle2';

  const sxStyle = {
    width: '100%',
    borderRadius: 2,
    py: 0.5,
    px: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'default',
    ...statusStyles[colorKey],
  };

  return (
    <Box sx={sxStyle}>
      <Typography
        variant={variant}
        noWrap
        sx={{ textAlign: 'center', fontWeight: 500 }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AutoAssignTaskStatus;
